import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { Autocomplete, Button, Stack, TextField } from "@mui/material";
import { forwardRef, useEffect, useState } from "react";
import Modal, { CommonModalProps } from "..";
import { cacheService, userService } from "../../../Core/Api/services";
import { DbUserBasicInfos } from "../../../Core/Api/Types/db-user-basic-infos";
import useCustomSnackbar from "../../../Utils/Hooks/useCustomSnackbar";
import { useTranslation } from "react-i18next";

export type ModalUserEmulateElementProps = {};

export type ModalUserEmulateProps = CommonModalProps<ModalUserEmulateElementProps>;

const ModalUserEmulate = forwardRef<any, ModalUserEmulateProps>((props, ref) => {
  const { closeModal, ...modalProps } = props;
  const { t } = useTranslation();
  const enqueueCustomSnackbar = useCustomSnackbar();
  const [users, setUsers] = useState<DbUserBasicInfos[]>([]);
  const [user, setUser] = useState<DbUserBasicInfos | undefined>(undefined);

  const handleEmulate = () => {
    userService.LoginEmulate(user?.id!).then((response) => {
      if (response.success) {
        // Keep origin values
        cacheService.SetEmulateUser();

        // Store new data as replacement
        cacheService.SetAuth(response);

        enqueueCustomSnackbar(t("alert:success.loggedInUnderIdentity", { userName: user?.name }), "success");
      } else enqueueCustomSnackbar(t("alert:error.emulation"), "error");

      closeModal();
    });
  };

  useEffect(() => {
    userService.GetAllUsersBasic().then((data) => {
      if (data.users) setUsers(data.users.filter((x) => x.enabled && !x.deleted));
    });
  }, []);

  return (
    <Modal
      title={t("modal:title.emulateAnotherUserAccount")}
      reference={ref}
      closeModal={closeModal}
      width={600}
      footer={
        <Stack direction="row" justifyContent="space-between">
          <Button variant="outlined" onClick={closeModal}>
            {t("common:cancel")}
          </Button>
          <Button variant="outlined" color="success" disabled={!user} onClick={handleEmulate}>
            {t("common:emulate")}
          </Button>
        </Stack>
      }
    >
      <Stack spacing={2}>
        <Autocomplete
          sx={{ mt: -3 }}
          popupIcon={<ExpandMoreRoundedIcon />}
          options={users}
          getOptionLabel={(option) => `${option.name} - ${option.login}`}
          value={user || null}
          onChange={(event, value) => setUser(value!)}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          renderInput={(params) => <TextField {...params} placeholder={t("field:placeholder.selectUserToEmulate")} />}
        />
      </Stack>
    </Modal>
  );
});

export default ModalUserEmulate;
